import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import { BareNumberInput } from '@entrata/portals-common/lib/components/forms'
import {
  CurrencyField,
  PickerField,
  RadioGroup,
} from '@entrata/portals-common/lib/boxed-fields'
import { RadioButton } from 'portal-modules/common/components/radio-button'
import { connect } from 'react-redux'
import Media from 'react-media'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

const StyledLabel = styled('label')`
  color: ${({ theme }) => theme.text.dark};
  display: block;
  font-size: 16px;

  @media screen and (min-width: 768px) {
    font-size: 11px;
  }
`

const StyledButton = styled(Button)`
  height: 32px;
  border: 1px solid pink;
  padding: 6px 16px;
  margin-top: 28px;
  span {
    font-size: 12px;
  }

  @media only screen and (max-width: 420px) {
    height: 64px;
    span {
      font-size: 16px;
    }
  }
`

const StyledBareNumber = styled(BareNumberInput)`
  border: 1px solid ${({ theme }) => theme.fields.border};
  font-size: inherit;
  height: 40px;
  padding: 0 8px;
  width: 96px;

  &:focus {
    border: 1px solid ${({ theme }) => theme.secondary.base};
    outline: none;
  }
`

const StyledWrapperDiv = styled('div')`
  @media screen and (min-width: 768px) {
    display: contents;
    justify-content: space-evenly;
    width: 100%;
    max-width: 550px;
  }
`

const StyledPickerField = styled(PickerField)`
  margin-bottom: 8px;
  display: flex;

  @media screen and (min-width: 768px) {
    margin-bottom: 0;

    button {
      height: 40px;
      padding: 0;
      width: 40px;
    }
  }
`

const StyledRentWrapper = styled('div')`
  display: flex;
  justify-content: space-between;

  > div {
    width: calc(50% - 8px);
  }
`

const SlimCurrencyField = ({ label, name, onUpdate, value }) => (
  <div>
    <StyledLabel>{label}</StyledLabel>
    <StyledBareNumber
      id={name}
      name={name}
      onChange={value => onUpdate({ name, value })}
      prefix={i18nUtils.getFullCurrencySymbol(
        i18nUtils.getLocale(),
        i18nUtils.getCurrency(),
      )}
      className={'boxed-field'}
      value={value}
    />
  </div>
)

SlimCurrencyField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  value: PropTypes.string,
}

const initialState = {
  bathrooms: [],
  bedrooms: [],
  floors: [],
  max_rent: null,
  min_rent: null,
  pets_allowed: '0',
}

class FloorPlanFilters extends Component {
  state = initialState

  handleReset = () => {
    const { onClose } = this.props
    this.setState(
      {
        ...initialState,
      },
      () => typeof onClose === 'function' && onClose(),
    )
  }

  handleUpdate = ({ name, type, value }) => {
    if (!type || value) {
      this.setState({
        [name]: value,
      })
    }
  }

  handleFilter = ({ values }) => {
    const { onClose, onFilter } = this.props
    onFilter(values)
    onClose && onClose()
  }

  componentDidMount = () => {
    const { onReset } = this.props
    // Supplying this method to the parent component as this need to be executed from the title bar of the modal
    onReset && onReset(this.handleReset)
  }

  render() {
    const {
      onClose,
      onFilter,
      disablePets,
      disableFloors,
      listBedRooms,
      listBathRooms,
      isLeaseAndRentWordReplaced
    } = this.props

    const { bathrooms, bedrooms, floors, max_rent, min_rent, pets_allowed } =
      this.state
    const rentReplacedText = isLeaseAndRentWordReplaced ? 'Housing Fee' : 'Rent'
    return (
      <StyledWrapperDiv>
        <Media query='(min-width: 768px)'>
          {largeScreen => (
            <Fragment>
              <div>
                <StyledLabel>{__('Bedrooms')}</StyledLabel>
                <StyledPickerField
                  allowMultiple
                  name='bedrooms'
                  onUpdate={this.handleUpdate}
                  value={bedrooms}
                >
                  {listBedRooms.map((item, index) => (
                    <PickerField.Option value={item} key={index}>
                      {item}
                    </PickerField.Option>
                  ))}
                </StyledPickerField>
              </div>
              <div>
                <StyledLabel>{__('Bathrooms')}</StyledLabel>
                <StyledPickerField
                  allowMultiple
                  name='bathrooms'
                  onUpdate={this.handleUpdate}
                  value={bathrooms}
                >
                  {listBathRooms.map((item, index) => (
                    <PickerField.Option value={item} key={index}>
                      {item}
                    </PickerField.Option>
                  ))}
                </StyledPickerField>
              </div>
              {largeScreen ? (
                <Fragment>
                  <SlimCurrencyField
                    label={__('Min. {%s, 0}' , [rentReplacedText])}
                    name='min_rent'
                    onUpdate={this.handleUpdate}
                    required={true}
                    value={min_rent}
                  />
                  <SlimCurrencyField
                    label={__('Max. {%s, 0}', [rentReplacedText])}
                    name='max_rent'
                    required={true}
                    onUpdate={this.handleUpdate}
                    value={max_rent}
                  />
                </Fragment>
              ) : (
                <Fragment>
                  <Fragment>
                    <StyledLabel>{__(rentReplacedText)}</StyledLabel>
                    <StyledRentWrapper>
                      <CurrencyField
                        label={__('Min Amt')}
                        name='min_rent'
                        onUpdate={this.handleUpdate}
                        value={min_rent}
                        required={true}
                        customPrefix={i18nUtils.getFullCurrencySymbol(
                          i18nUtils.getLocale(),
                          i18nUtils.getCurrency(),
                        )}
                      />
                      <CurrencyField
                        label={__('Max Amt')}
                        name='max_rent'
                        onUpdate={this.handleUpdate}
                        value={max_rent}
                        required={true}
                        customPrefix={i18nUtils.getFullCurrencySymbol(
                          i18nUtils.getLocale(),
                          i18nUtils.getCurrency(),
                        )}
                      />
                    </StyledRentWrapper>
                  </Fragment>
                  {!disableFloors && (
                    <Fragment>
                      <StyledLabel>{__('Floors')}</StyledLabel>
                      <StyledPickerField
                        allowMultiple
                        name='floors'
                        onUpdate={this.handleUpdate}
                        value={floors}
                      >
                        {Array.from(new Array(largeScreen ? 2 : 3)).map(
                          (x, index) => (
                            <PickerField.Option value={index + 1} key={index}>
                              {index + 1}
                            </PickerField.Option>
                          ),
                        )}
                      </StyledPickerField>
                    </Fragment>
                  )}
                  {!disablePets && (
                    <RadioGroup
                      label={__('Allows Pets')}
                      name='pets_allowed'
                      onUpdate={this.handleUpdate}
                      required
                      value={pets_allowed}
                    >
                      {({ getItemProps }) => (
                        <React.Fragment>
                          <RadioButton
                            label={__('No')}
                            {...getItemProps({ value: '0' })}
                          />
                          <RadioButton
                            label={__('Yes')}
                            {...getItemProps({ value: '1' })}
                          />
                        </React.Fragment>
                      )}
                    </RadioGroup>
                  )}
                </Fragment>
              )}

              <StyledButton
                appearance='primary'
                css={
                  largeScreen
                    ? css`
                        margin-top: 16px;
                        max-height: 40px;
                      `
                    : {}
                }
                slim={largeScreen}
                onClick={() => (onFilter(this.state), onClose && onClose())}
              >
                {largeScreen ? __('Filter') : __('Save Filters')}
              </StyledButton>
            </Fragment>
          )}
        </Media>
      </StyledWrapperDiv>
    )
  }
}

FloorPlanFilters.propTypes = {
  onClose: PropTypes.func,
  onFilter: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  disablePets: PropTypes.bool,
  disableFloors: PropTypes.bool,
  listBathRooms: PropTypes.array,
  listBedRooms: PropTypes.array,
  isLeaseAndRentWordReplaced: PropTypes.bool
}

FloorPlanFilters.defaultProps = {
  disablePets: false,
  disableFloors: false,
  listBathRooms: [],
  listBedRooms: [],
}
export default connect(({ productPermissions }) => ({
  isLeaseAndRentWordReplaced:
    productPermissions?.replace_lease_and_rent || false,
}))(FloorPlanFilters)
